export const mutations = {
  setEmpresa(state, data) {
    state.empresa = data;
  },
  setEmpresas(state, data) {
    state.empresas = data;
  },
  addEmpresa(state, data) {
    state.empresas.push(data);
  },
  removeEmpresa(state, data) {
    let index = state.empresas.map((x) => x.id).indexOf(data.id);
    state.empresas.splice(index, 1);
  },
  setModalCadastrarEmpresa(state, status) {
    state.modalCadastrarEmpresa = status;
  },
  setModalExcluirEmpresa(state, status) {
    state.modalExcluirEmpresa = status;
  },
  setModalPesquisarEmpresa(state, status) {
    state.modalPesquisarEmpresa = status;
  },
};

export default {};
